import { For, Show } from 'solid-js';
import styles from './BotAvatarStack.module.css';

interface BotAvatarStackProps {
    bots: readonly { id: string; minecraftUuid: string; minecraftUsername: string }[];
    max?: number;
}

export default function BotAvatarStack(props: BotAvatarStackProps) {
    const max = () => props.max ?? 4;
    const shown = () => props.bots.slice(0, max());
    const hiddenCount = () => props.bots.length - shown().length;

    return (
        <span class={styles.stack}>
            <For each={shown()}>{(b) => (
                <img
                    class={styles.avatar}
                    src={`https://mc-heads.net/avatar/${b.minecraftUuid}/24`}
                    alt=""
                    title={b.minecraftUsername}
                />
            )}</For>
            <Show when={hiddenCount() > 0}>
                <span class={styles.more}>+{hiddenCount()}</span>
            </Show>
        </span>
    );
}
